import { render, staticRenderFns } from "./CrearFuncionesGlobales.vue?vue&type=template&id=c8bc4758&"
import script from "./CrearFuncionesGlobales.vue?vue&type=script&lang=ts&"
export * from "./CrearFuncionesGlobales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c8bc4758', component.options)
    } else {
      api.reload('c8bc4758', component.options)
    }
    module.hot.accept("./CrearFuncionesGlobales.vue?vue&type=template&id=c8bc4758&", function () {
      api.rerender('c8bc4758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/FuncionesGlobales/CrearFuncionesGlobales.vue"
export default component.exports